import {
  ALL_SITE_CATALYST_TRACKING_VARIABLES,
  PRODUCTS_TRACKING_VAR,
  EVENTS_TRACKING_VAR
} from '@/constants/SiteCatalystConstants';

function siteCatalystObjectExists(): boolean {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return window && window.s;
}

function setProducts(fact: string) {
  const products = JSON.parse(fact[PRODUCTS_TRACKING_VAR]);
  if (products && products.length > 0) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.s[PRODUCTS_TRACKING_VAR] = `;${products.join(',;')}`;
  }
}

function setTrackingVariableValueOnSiteCatalystWindowObject(trackingVariable: string, fact: string) {
  const trackingVariableName = ALL_SITE_CATALYST_TRACKING_VARIABLES[trackingVariable];

  if (trackingVariableName === PRODUCTS_TRACKING_VAR && fact[PRODUCTS_TRACKING_VAR]) {
    setProducts(fact);
  } else if (trackingVariableName === EVENTS_TRACKING_VAR && fact[EVENTS_TRACKING_VAR]) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.s[trackingVariableName] = JSON.parse(fact[EVENTS_TRACKING_VAR]).join(',');
  } else {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.s[trackingVariableName] = fact[trackingVariableName];
  }
}

export default function siteCatalystAnalyticsReporter() {
  return fact => {
    if (!siteCatalystObjectExists()) {
      return;
    }

    // Start with a clean instance object
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.s.clearVars();

    Object.keys(ALL_SITE_CATALYST_TRACKING_VARIABLES).forEach(key => {
      if (Object.prototype.hasOwnProperty.call(ALL_SITE_CATALYST_TRACKING_VARIABLES, key)) {
        setTrackingVariableValueOnSiteCatalystWindowObject(key, fact);
      }
    });

    // Make the tracking call
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.s.t();
  };
}
